export const THUMB_TYPES = {
  UP: 'Up',
  DOWN: 'Down',
} as const;

export const THUMB_STYLES = {
  LIGHT: 'Light',
  DARK: 'Dark',
  SWITCH: 'Switch',
} as const;

export const THUMB_LOCATIONS = {
  BACKSTAGE: 'backstage',
} as const;
